<div class="page-content page-fill">
    <div class="grid-fill" *ngIf="schedulerData">
        <div class="d-flex mb-1">
            <div class="column me-3"><span class="status status-wip"></span> - Scheduled</div>
            <div class="column me-4"><span class="status status-pack-slip-created"></span> - Scheduled, No Jig</div>
            <div class="column me-3"><span class="status status-ready-to-deliver"></span> - Due, Not Scheduled</div>
            <!-- <div class="column me-3"><span class="status status-built"></span> - Built</div>
            <div class="column me-3"><span class="status status-stacked"></span> - Stacked</div>
            <div class="column me-3"><span class="status status-delivered"></span> - Delivered</div>
            <div class="column me-3"><span class="status status-jig-completed"></span> - Scheduled, No Jig</div> -->
            <div class="d-flex align-items-center me-3">
                <label class="me-1">Status</label>
                <dx-tag-box
                    style="min-width: 250px; max-width: 500px"
                    [(value)]="filter.statuses"
                    [items]="statuses"
                    [showSelectionControls]="true"
                    [showDropDownButton]="true"
                    [disabled]="uow.hasChanges()"
                    (onValueChanged)="statusChanged($event)"
                ></dx-tag-box>
            </div>
            <div>
                <button (click)="save()" class="btn btn-primary me-2" [disabled]="!uow.hasChanges()">Save</button>
                <button (click)="cancel()" class="btn btn-success" [disabled]="!uow.hasChanges()">Cancel</button>
            </div>
        </div>
        <dx-scheduler
            #scheduler
            class="scheduler"
            [dataSource]="schedulerData"
            [views]="['month', 'year', 'week']"
            [currentView]="'Year'"
            [currentDate]="currentDate"
            [startDayHour]="0"
            [endDayHour]="24"
            [height]="1000"
            (onCellContextMenu)="onCellContextMenu($event)"
            (onAppointmentContextMenu)="onAppointmentContextMenu($event)"
            appointmentTemplate="appointment-template"
            appointmentTooltipTemplate="tooltip-template"
            (onContentReady)="onContentReady($event)"
            (onAppointmentDblClick)="onDoubleClick($event)"
            (onAppointmentUpdated)="onAppointmentUpdated($event)"
        >
            <dxo-editing [allowAdding]="false" [allowDeleting]="false" [allowDragging]="false" [allowResizing]="false" [allowUpdating]="false"></dxo-editing>
            <dxi-resource fieldExpr="statusColorId" [allowMultiple]="true" [dataSource]="statusColors" [useColorAsDefault]="true"> </dxi-resource>

            <div *dxTemplate="let data of 'appointment-template'">
                <div>{{ data.appointmentData.dealerCompanyName }} -- {{ data.appointmentData.partNumber }}</div>
            </div>
            <!-- <dxi-view name="Day" type="day" [intervalCount]="1"></dxi-view>
            <dxi-view name="Week" type="week" [intervalCount]="1"></dxi-view> -->
            <dxi-view name="Month" type="month" [intervalCount]="1"></dxi-view>
            <dxi-view name="Year" type="month" [intervalCount]="12"></dxi-view>
            <dxi-view name="Week" type="week" [intervalCount]="1"></dxi-view>

            <dxo-editing [allowUpdating]="true" [allowDragging]="true"></dxo-editing>

            <div *dxTemplate="let data of 'tooltip-template'">
                <div class="dx-scheduler-tooltip">
                    <div>Order #: {{ data.appointmentData.salesOrderNumber }}</div>
                    <div>Dealer: {{ data.appointmentData.dealerCompanyName }}</div>
                    <div>Part #: {{ data.appointmentData.partNumber }}</div>
                    <div>Status: {{ data.appointmentData.statusName }}</div>
                </div>
            </div>
        </dx-scheduler>
        <dx-context-menu
            #appointmentMenu
            [dataSource]="appointmentContextMenuItems"
            target=".dx-scheduler-appointment"
            (onItemClick)="onContextMenuItemClick($event)"
            [width]="200"
        ></dx-context-menu>
        <dx-context-menu #cellMenu [dataSource]="cellContextMenuItems" target=".dx-scheduler-date-table-cell" (onItemClick)="onContextMenuItemClick($event)" [width]="200">
        </dx-context-menu>
    </div>
</div>
